import { Button } from '@mui/material';
import { useEffect, useState } from 'react';
import { MarkItViewApi } from '../../../../Apis/Apis';
import { CompanyModel, MarketViewUserModel } from '../../../../Generated/Mark-It-View-Api';
import { useLoadingState } from '../../../../Hooks';
import { StoneXLoading, StoneXRow } from '../../../StoneX';
import StoneXMainPage from '../../../StoneX/StoneXMainPage/StoneXMainPage';
import { MarketViewUsersTable } from './MarketViewUsersTable';
import { AddUserRequest, saveMarketViewUser, updateMarketViewUserEnabled } from './MarketViewUserAdminLogic';
import { UpdateUserModal } from './UpdateUserModal';

export default function Users() {
  const [siteUsers, setSiteUsers] = useState<MarketViewUserModel[]>([]);
  const [companies, setCompanies] = useState<CompanyModel[]>([]);
  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const [modalUser, setModalUser] = useState<MarketViewUserModel | undefined>();
  const usersLoadingState = useLoadingState();
  const companiesLoadingState = useLoadingState();
  
  const saveUserLoadingState = useLoadingState();

  useEffect(() => {
    MarkItViewApi.listMarketViewUsers(usersLoadingState.setLoadingState, undefined, undefined, true)
      .then((usersResponse) => {
        setSiteUsers(usersResponse.data.rows ?? []);
      });

    MarkItViewApi.listCompanies(companiesLoadingState.setLoadingState)
      .then((companiesResponse) => {
        setCompanies(companiesResponse.data.rows ?? []);
      });
  }, []);

  function saveUser(request: AddUserRequest) {
    saveMarketViewUser(request, saveUserLoadingState.setLoadingState).then((result) => {
      if (result.isNew) {
        setSiteUsers((previous) => [...previous, result.user]);
        return;
      }

      setSiteUsers((previous) =>
        previous.map((user) =>
          user.marketViewUserGuid === result.user.marketViewUserGuid
            ? result.user
            : user,
        ),
      );
    });
  }

  function openModal() {
    setModalUser(undefined);
    setModalOpen(true);
  }

  function updateUser(user: MarketViewUserModel) {
    setModalUser(user);
    setModalOpen(true);
  }

  function closeModal() {
    setModalOpen(false);
    setModalUser(undefined);
  }
  function updateEnabledStatus(data: MarketViewUserModel): void {
    updateMarketViewUserEnabled(data)
      .then(() => {
        setSiteUsers((previous) =>
          previous.map((user) =>
            user.marketViewUserGuid === data.marketViewUserGuid
              ? { ...user, isDisabled: !user.isDisabled }
              : user
          )
        );
      });
  }

  if (usersLoadingState.isLoading() || companiesLoadingState.isLoading()) {
    return (
      <StoneXMainPage>
        <StoneXLoading show />
      </StoneXMainPage>
    );
  }

  return (
    <StoneXMainPage>
      <StoneXRow align="baseline">
        <h1>Users</h1>
        <Button className="pull-right" variant="outlined" onClick={openModal}>
          Add
        </Button>
      </StoneXRow>

      <MarketViewUsersTable
        users={siteUsers}
        companies={companies}
        showActions
        onUpdateUser={updateUser}
        onToggleUserEnabled={updateEnabledStatus}
      />
      <UpdateUserModal open={modalOpen} onClose={closeModal} onUserSave={saveUser} user={modalUser} companies={companies}/>
    </StoneXMainPage>
  );
}
